export default __webpack_public_path__ + "static/media/govconext-logo.88de127e.svg";